import * as translations from '.';

const localeToTranslations: Record<string, Record<string, string>> = {
	'cs-CZ': translations.cs,
	'da-DK': translations.da,
	'de-DE': translations.de,
	'en-US': translations.en,
	'en-GB': translations.en_GB,
	'en-ZZ': translations.en_ZZ,
	'es-ES': translations.es,
	'fi-FI': translations.fi,
	'fr-FR': translations.fr,
	'hu-HU': translations.hu,
	'it-IT': translations.it,
	'ja-JP': translations.ja,
	'ko-KR': translations.ko,
	'no-NO': translations.nb,
	'nl-NL': translations.nl,
	'pl-PL': translations.pl,
	'pt-BR': translations.pt_BR,
	'ru-RU': translations.ru,
	'sv-SE': translations.sv,
	'tr-TR': translations.tr,
	'th-TH': translations.th,
	'uk-UA': translations.uk,
	'vi-VN': translations.vi,
	'zh-TW': translations.zh_TW,
	'zh-CN': translations.zh,
};

const fetchTranslations = async (locale: string): Promise<Record<string, string>> =>
	localeToTranslations[locale] ?? translations.en;

export default fetchTranslations;
